import React from "react";
import { Tick } from "@sainsburys-tech/luna-icons";

const ValidIcon = () => (
  <Tick className="ln-u-color-green" role="presentation" />
);

const PasswordTicksForgottenPassword = ({ passwordValidation }) => {
  return (
    <div className="ln-u-margin-bottom*2">
      <p className="ln-u-display-inline-block ln-u-margin-bottom*2">
        Your password must:
      </p>
      <ul className="forgotten-password__tick-list">
        <li>
          <span className="tick">
            {passwordValidation.length && <ValidIcon />}
          </span>
          <span id="password-validation-length">
            Have a minimum of 9 characters
          </span>
        </li>
        <li>
          <span className="tick">
            {passwordValidation.uppercase &&
              passwordValidation.lowercase &&
              passwordValidation.digit && <ValidIcon />}
          </span>
          <span id="password-validation-content">
            Contain at least 1 uppercase letter, 1 lowercase letter and 1 number
          </span>
        </li>
        <li>
          <span className="tick">
            {passwordValidation.specialChars && <ValidIcon />}
          </span>
          <span id="password-validation-specialchar">
            Contain at least 1 special character (i.e # & ? @ _ *)
          </span>
        </li>
        <li>
          <span className="tick">
            {passwordValidation.space && <ValidIcon />}
          </span>
          <span id="password-validation-spaces">Have no spaces</span>
        </li>
      </ul>
      <p id="password-validation-different">
        Be different to your name, email or previous password
      </p>
    </div>
  );
};

export default PasswordTicksForgottenPassword;
